import { css } from 'goober';

export const DefaultTheme = css`

  --moba-widget-text-primary-light: #ffffff;
  --moba-widget-text-primary-dark: #8890b5;
  --moba-widget-text-secondary: #6b6889;

  --moba-widget-base-100: #382f66;
  --moba-widget-grey-100: #b3b4d0;
  --moba-widget-base-500: #151136;
  --moba-widget-grey-300: #6b6889;

  --moba-widget-link-primary: #f2bf43;
  --moba-widget-link-hover: #38C6F4;

  --moba-widget-abbility-tooltip-bg: #19133d;
  --moba-widget-bg-primary-light: #3C385C;
  --moba-widget-bg-primary-dark: #252046;
  --moba-widget-bg-secondary-light: #2c274e;
  --moba-widget-bg-secondary-dark: #151136;

  --moba-widget-skeleton-primary: #3C385C;

  --moba-widget-tooltip-bg: #151136;
  --moba-widget-tooltip-border: #2f2650;

  --moba-widget-border-primary-dark: #2f2650;
  --moba-widget-border-primary-light: #382f66;
  --moba-widget-border-secondary-dark: #141136;
  --moba-widget-border-secondary-light: #F2BF43;

  --moba-widget-metric-wr-poor: #E54787;
  --moba-widget-metric-wr-average: #FFFFFF;
  --moba-widget-metric-wr-good: #1DC49B;
  --moba-widget-metric-wr-great: #85D0FF;

  --moba-widget-skill-key-passive: #FFC306;
  --moba-widget-skill-key-q: #38C6F4;
  --moba-widget-skill-key-w: #47CC42;
  --moba-widget-skill-key-e: #FF2576;
  --moba-widget-skill-key-r: #858cb2;

  --moba-widget-perk-8000: #f2bf43;
  --moba-widget-perk-8100: #ca3e3f;
  --moba-widget-perk-8200: #9ea9fb;
  --moba-widget-perk-8300: #49aab9;
  --moba-widget-perk-8400: #a1d586;
  --moba-widget-perk-default: #fff;

`;

export const FandomDarkTheme = css`

  --moba-widget-text-primary-dark: #ffffff;
  --moba-widget-text-secondary: #8E9AA7;
  --moba-widget-link-primary: #f2bf43;
  --moba-widget-link-hover: #38C6F4;

  --moba-widget-bg-primary-light: #061E36;
  --moba-widget-bg-primary-dark: #061E36;
  --moba-widget-bg-secondary-light: #00294c;

  --moba-widget-skeleton-primary: #223E5B;

  --moba-widget-tooltip-bg: #061E36;
  --moba-widget-tooltip-border: #061E36;

  --moba-widget-border-primary-light: #3c5a75;

  --moba-widget-skill-key-passive: #FFC306;
  --moba-widget-skill-key-q: #FFC306;
  --moba-widget-skill-key-w: #38C6F4;
  --moba-widget-skill-key-e: #47CC42;
  --moba-widget-skill-key-r: #FF2576;

  --moba-widget-metric-wr-average: #F5F3F5;

`;

export const FandomLightTheme = css`

  --moba-widget-text-primary-light: #3A3A3A;
  --moba-widget-text-primary-dark: #3A3A3A;
  --moba-widget-text-secondary: #84817D;

  --moba-widget-link-primary: #6574FF;
  --moba-widget-link-hover: #38C6F4;

  --moba-widget-bg-primary-light: #e7dacb;
  --moba-widget-bg-primary-dark: #E7DACB;
  --moba-widget-bg-secondary-light: #F2EBE2;

  --moba-widget-tooltip-bg: #E7DACB;
  --moba-widget-tooltip-border: #e7dacb;

  --moba-widget-skeleton-primary: #C9BAA3;

  --moba-widget-border-primary-light: #cdc6bc;
  --moba-widget-border-secondary-light: #6574ff;

  --moba-widget-skill-key-passive: #FFC306;
  --moba-widget-skill-key-q: #FF06D7;
  --moba-widget-skill-key-w: #2EACD4;
  --moba-widget-skill-key-e: #2DB128;
  --moba-widget-skill-key-r: #ff2576;

  --moba-widget-metric-wr-poor: #FF2576;
  --moba-widget-metric-wr-average: #3A3A3A;
  --moba-widget-metric-wr-good: #14990F;
  --moba-widget-metric-wr-great: #85D0FF;

`;
